import useAuthRoutes from 'routes/useAuthRoutes';

function App() {
  const routes = useAuthRoutes();

  return <div className='ezAppLayout'>{routes}</div>;
}

export default App;
